import { radioSelectClasses } from '@private/components';
import { Form } from 'formik';
import styled from 'styled-components';

import FormikRadioSelect from 'components/Form/FormikRadioSelect';

export const PopoverContainer = styled.div`
  width: 250px;
  padding: 10px 0 10px 14px;
`;

export const StyledForm = styled(Form)`
  padding-right: 14px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: right;
`;

export const StyledRadioSelect = styled(FormikRadioSelect)`
  padding: 10px 0px;

  ${radioSelectClasses.radioGroup} {
    display: grid;
    grid-gap: 15px;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`;
